import { useEffect } from "react";
import { Link, createFileRoute } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { RequireAuth } from "@/components/RequireAuth";
import { AppShell } from "@/components/layout/AppShell";
import { CashReceiptForm } from "@/components/treasury/CashReceiptForm";
import { useActiveCompany } from "@/lib/company-context";

export const Route = createFileRoute("/companies/$companyId/recibos/new")({
  component: NewCashReceiptPage,
});

function NewCashReceiptPage() {
  return (
    <RequireAuth>
      <AppShell>
        <NewCashReceiptContent />
      </AppShell>
    </RequireAuth>
  );
}

function NewCashReceiptContent() {
  const { t } = useTranslation();
  const { companyId } = Route.useParams();
  const { setActiveCompanyId } = useActiveCompany();

  useEffect(() => {
    if (companyId) setActiveCompanyId(companyId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId]);

  return (
    <div className="mx-auto flex max-w-6xl flex-col gap-6">
      <div>
        <Link
          to="/companies/$companyId/recibos"
          params={{ companyId }}
          className="inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground"
        >
          <ArrowLeft className="h-3 w-3" />
          {t("cashReceipts.new.back")}
        </Link>
        <h1 className="mt-1 text-2xl font-semibold tracking-tight">
          {t("cashReceipts.new.title")}
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">
          {t("cashReceipts.new.subtitle")}
        </p>
      </div>
      <CashReceiptForm companyId={companyId} />
    </div>
  );
}
